/**
 * Lets code outside the React tree (e.g. QueryCache.onError, which runs from
 * inside react-query's core, not from a component) show a toast. ToastProvider
 * registers itself here on mount.
 */
import type { ToastProps } from './toast-context-definition';

type ToastFn = (props: ToastProps) => void;

let activeToast: ToastFn | null = null;

export function registerToastBridge(toast: ToastFn) {
  activeToast = toast;
}

export function unregisterToastBridge(toast: ToastFn) {
  if (activeToast === toast) {
    activeToast = null;
  }
}

export function showBridgedToast(props: ToastProps) {
  activeToast?.(props);
}
